import { CleanButton } from '@gassan-ui'
import { cn } from '@lib/cn'
import { FC, HTMLAttributes } from 'react'

type Props = HTMLAttributes<HTMLElement> & {
  activeIndex: number
  count: number
  onClick: (index: number) => void
}

const Indicators: FC<Props> = ({ activeIndex, count, onClick, className }) => (
  <div className={cn('-mt-2 mb-7 grid grid-flow-col justify-center gap-2 sm:gap-5', className)}>
    {Array.from(new Array(count)).map((_, index) => {
      return (
        <CleanButton key={index} onClick={() => onClick(index)} py="0.5rem">
          <span
            className={cn(
              'row-[1] block h-1 w-10 rounded outline-none transition-colors duration-150 sm:w-20',
              activeIndex === index ? 'bg-rolexPrimary' : 'bg-rolexShade-300',
            )}
          />
        </CleanButton>
      )
    })}
  </div>
)

export default Indicators
